export function isLegacy() {
  const { isUnifiedAccount = false } = window.okGlobal;
  return !isUnifiedAccount;
}

export function getLegacyPageLink() {
  const isLegacyAccount = isLegacy();

  let spotBillsRage;
  let spotOrders;
  let spotPage;
  if (isLegacyAccount) {
    spotBillsRage = '/spot/bills';
    spotOrders = '/spot/orders';
    spotPage = '/spot/trade';
  } else {
    spotBillsRage = '/account/balance/transaction/reportCenter/account-history';
    spotOrders = '/account/balance/transaction/reportCenter/order-open';
    spotPage = '/trade-spot';
  }

  return {
    spotBillsRage,
    spotOrders,
    spotPage,
  };
}
